<h1 mat-dialog-title>{{data.title}}</h1>
@if (descriptionContainsHTML) {
  <div mat-dialog-content [innerHTML]="data.description">
  </div>
} @else {
  <div mat-dialog-content>
    <p [innerHTML]="data.description"></p>
  </div>
}
<div mat-dialog-actions>
  @if (!data.hideCancel) {
    <button mat-button (click)="onNoClick()">{{ 'generic.cancel' | translate | uppercase }}</button>
  }
  <span class="spacer"></span>
  <button mat-button (click)="confirm()" color="primary" cdkFocusInitial>{{ 'generic.ok' | translate }}</button>
</div>
